import React from 'react'
import { useDispatchCart as uDispatchCart, useCart as uCart } from '../reducer/contextReducer'
import {useNavigate as uNavigate} from 'react-router-dom'

export default function productDesc(props) {
    const navigate=uNavigate()
    let dispatch = uDispatchCart()
    let data = uCart()

    let medprod = props.medProduct
    
    let ProdTitle = medprod.productTitle
    let ProdType = medprod.productType
    let medImg = medprod.productImage
    
    let price = parseInt(medprod.productAmount)

    const handleAddToCart = async () => {
        if (localStorage.getItem('userEmail')){
            let med = []
            for (const item of data) {
                if (item.id === medprod._id) {
                    med = item
                    break
                }
            }

            if (med !== []) {
                if (med.productQuantity === medprod.productQuantity) {
                    await dispatch({ type: "UPDATE", id: medprod._id, productAmount: price, productQuantity: med.productQuantity })
                    return
                }
                else if (med.productQuantity !== medprod.productQuantity) {
                    await dispatch({ type: "ADD", id: medprod._id, productImage: medprod.productImage, productTitle: medprod.productTitle, productQuantity: medprod.productQuantity, productType: medprod.productType, productAmount: price })
                    return
                }
                return
            }
            await dispatch({ type: "ADD", id: medprod._id, productImage: medprod.productImage, productTitle: medprod.productTitle, productQuantity: medprod.productQuantity, productType: medprod.productType, productAmount: price })            
        }
        else {
            alert('please login first')
            navigate('/login')
        }
    }
  return (
      <>


          <div className="card mb-3" >
              <div className="row g-0">
                  <div className="col-md-4">
                      <img src={medImg.includes('http') ? medImg : `http://localhost:8000/public/images/${medImg}`} className="img-fluid rounded-start" alt="..."/>
                  </div>
                  <div className="col-md-8">
                      <div className="card-body">
                          <h5 className="card-title">{ProdTitle}</h5>
                          <p className="card-text">{medprod.productDescription}</p>
                          <p className="card-text">Salts: {medprod.productSalt}</p>
                          <div className="detail-box">
                              <div className="text">
                                  <h6>
                                      {ProdType}
                                  </h6>
                                  <h6 className="price">
                                      <span>
                                          ₹
                                      </span>
                                      {price}
                                  </h6>
                              </div>
                          </div>
                          <button onClick={handleAddToCart} className="btn btn-success">Add To Cart</button>                          
                          <p className="card-text"><small className="text-body-secondary">Expires in 3 Months of Manufactured date</small></p>
                      </div>
                  </div>
              </div>
          </div>
      
      </>
  )
}
